module.exports = __webpack_public_path__ + "static/img/6280_phase_function_Paper_PointsHejduk_Prediction.7900bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6280_phase_function_Paper_PointsHejduk_Prediction.png
// module id = wcmB
// module chunks = 0